import { useEffect } from 'react';
import { useAppDispatch } from '../../../hooks/redux';
import { getExperimentGroup, postExposure } from '../../../laboratory';
import { updateNavItemTrialState } from '../../../reducers/navItems';
import { useExperiments, usePortal, useUser } from '../../../hooks/useNavConfig';
import useNavItems from '../../../hooks/useNavItems';
import { allFreeIds, lockedFreeIds } from '../../../constants/HC_0130';
export const convertByIdToIds = features => {
  return Object.values(features).map(feature => feature.id);
};
function findDifference(baseArray, comparisonArray) {
  return comparisonArray.filter(item => !baseArray.includes(item));
}
export const useTrialBadge = ({
  isPaid,
  inTrial,
  isPaidLoaded,
  isProOrEntTrialLoaded
}) => {
  const dispatch = useAppDispatch();
  const {
    byId
  } = useNavItems();
  const {
    portalId,
    gates
  } = usePortal();
  const {
    scopes
  } = useUser();
  const experiments = useExperiments();
  useEffect(() => {
    const updateTrialBadgeState = () => {
      if (gates.includes('HiC:TrialBadgeInNav') && isPaidLoaded && isProOrEntTrialLoaded && scopes.includes('nav-trial-badges')) {
        if (!isPaid && inTrial) {
          void postExposure(['hc-0130'], `${portalId}`, {
            portalId
          });
          const experimentGroup = getExperimentGroup('hc-0130', experiments);
          if (experimentGroup === 'variation') {
            const unlockedIds = new Set(Object.values(byId).filter(feature => lockedFreeIds.includes(feature.id) && !feature.isLocked).map(feature => feature.id));
            const trialIds = new Set(convertByIdToIds(byId));
            const additionalUnlockedIds = new Set(findDifference(allFreeIds, Array.from(trialIds)));
            const allUnlockedIdsUnique = new Set([...unlockedIds, ...additionalUnlockedIds]);

            // If you need an array, you can convert the set back to an array
            const allUnlockedIds = Array.from(allUnlockedIdsUnique);
            dispatch(updateNavItemTrialState({
              inTrial: allUnlockedIds
            }));
          }
        }
      }
    };
    void updateTrialBadgeState();
  }, [byId, gates, isPaid, portalId, experiments, inTrial, dispatch, isPaidLoaded, isProOrEntTrialLoaded, scopes]);
};